import { Instagram, Linkedin, Youtube, Mail, Phone } from "lucide-react";
import { LOGO_URL, SOCIALS } from "@/lib/api";

const BehanceIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M22 7h-7V5h7v2zM5.5 6c1.93 0 3.5 1.34 3.5 3 0 .73-.3 1.39-.78 1.91 1.32.54 2.28 1.81 2.28 3.34 0 2.01-1.79 3.75-4 3.75H0V6h5.5zm-.5 4.5c.83 0 1.5-.67 1.5-1.5S5.83 7.5 5 7.5H2v3h3zM5 16c.83 0 1.5-.67 1.5-1.5S5.83 13 5 13H2v3h3zM19 9c2.21 0 4 2.24 4 5 0 .35-.04.69-.1 1H16c.4 1.16 1.4 2 2.5 2 .76 0 1.45-.4 1.85-1H22.3c-.6 1.75-2.4 3-4.3 3-2.5 0-4.5-2.24-4.5-5s2-5 4.5-5h1zM16 13h5c-.3-1.16-1.3-2-2.5-2-1.1 0-2.1.84-2.5 2z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="relative border-t border-[#264738] py-16 md:py-24" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <img src={LOGO_URL} alt="StyleePix" className="h-16 w-16 object-contain" />
              <div className="leading-none">
                <div className="font-display text-ivory text-xl tracking-[0.25em]">STYLEEPIX</div>
                <div className="text-xs tracking-[0.4em] text-gold mt-1">COLLECTIVE</div>
              </div>
            </div>
            <p className="text-ivory-muted text-sm font-light leading-relaxed max-w-sm">
              A hybrid digital content agency for fashion, beauty, lifestyle and product brands.
              India — and beyond.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.4em] text-gold mb-5">Contact</div>
            <a href={`mailto:${SOCIALS.email}`} className="flex items-center gap-2 text-ivory hover:text-gold text-sm mb-3">
              <Mail size={14} /> {SOCIALS.email}
            </a>
            <a href="tel:+918851915302" className="flex items-center gap-2 text-ivory hover:text-gold text-sm mb-3">
              <Phone size={14} /> +91 88519 15302
            </a>
            <a href="https://styleepix.co" className="block text-ivory hover:text-gold text-sm">
              www.styleepix.co
            </a>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.4em] text-gold mb-5">Follow</div>
            <div className="flex items-center gap-5">
              <a href={SOCIALS.instagram} target="_blank" rel="noreferrer" className="text-ivory hover:text-gold transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href={SOCIALS.behance} target="_blank" rel="noreferrer" className="text-ivory hover:text-gold transition-colors" aria-label="Behance">
                <BehanceIcon width="22" height="22" />
              </a>
              <a href={SOCIALS.linkedin} target="_blank" rel="noreferrer" className="text-ivory hover:text-gold transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href={SOCIALS.youtube} target="_blank" rel="noreferrer" className="text-ivory hover:text-gold transition-colors" aria-label="YouTube">
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="hairline mb-8" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] uppercase tracking-[0.3em] text-ivory-muted">
          <div>© {new Date().getFullYear()} StyleePix Collective. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="/admin" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Admin</a>
            <span>Designed in Delhi</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
